export default __webpack_public_path__ + "static/media/undraw_aircraft_fbvl.64dadc67.svg";